import React from 'react';
import { Text } from '../../design/components';
import { useSelector } from 'react-redux';

export default function DateText(props) {
  const { date, dateFormat, timeFormat, ...otherProps } = props;
  // const renderDate = useFormatDate(date, dateFormat, timeFormat);
  // console.log('DATETEXT', Locale.constants().localeDateFormats);
  const language = useSelector((state) => state.settings.language);
  let lang = language === 'default' ? navigator.language : language;
  //Intl.DateTimeFormat supports only zh-cn, not zh-rCN
  if (lang === 'zh-rCN') {
    lang = 'zh-cn';
  }
  const dateFormatter = new Intl.DateTimeFormat(lang, {
    dateStyle: dateFormat,
    timeStyle: timeFormat,
  });
  //const dateText = dateFormatter.format(date);
  const dateText = dateFormatter.format(date);
  return <Text {...otherProps}>{dateText}</Text>;
}
